export class Seccion
{
    public idSeccionPk: number;   
    public idAnt:number;
    public dsc: string;
    public idPlantillaFk: number;
    public idEsquemaFk: number;
    public esInternacional: Boolean;
    public esOtroEsquema: Boolean;
    public posicion: number;
}